var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import FetchService from "./Shared/FetchService";
import ServiceDeliveryLocationDomainService from "../Domain/ServiceDeliveryLocation/ServiceDeliveryLocation.service";
const BASE_URL = "/aviso/serviceDeliveryLocation";
export default class ServiceDeliveryLocationService {
    static getStaffServiceDeliveryLocationsForOldScheduler() {
        return FetchService.get("/aviso/advisor/getStaffServiceDeliveryLocations");
    }
    static getStaffServiceDeliveryLocationsForNewScheduler() {
        return FetchService.get("/aviso/advisor/getStaffServiceDeliveryLocationsForNewScheduler");
    }
    static search(search, options = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const searchResults = yield FetchService.getPagedResponse(BASE_URL + "/search", {
                query: search.query,
                ids: search.ids,
                excludeIds: search.excludeIds,
                active: search.active,
                locationIds: search.locationIds,
                allowSelfServiceCheckIn: search.allowSelfServiceCheckIn,
                selfServiceStaffPersonIds: search.selfServiceStaffPersonIds,
                showInLegacyScheduler: search.showInLegacyScheduler,
                showInNewScheduler: search.showInNewScheduler,
                sort: options.sort,
                order: options.order,
                max: options.max,
                offset: options.offset,
            });
            return Object.assign(Object.assign({}, searchResults), { data: searchResults.data.map(ServiceDeliveryLocationDomainService.fromJSON) });
        });
    }
    static get(serviceDeliveryLocationId) {
        return __awaiter(this, void 0, void 0, function* () {
            return FetchService.getSingleResponse(BASE_URL + "/get", {
                id: serviceDeliveryLocationId,
            });
        });
    }
    static save(request) {
        return __awaiter(this, void 0, void 0, function* () {
            return FetchService.postSingleResponse(BASE_URL + "/save", {
                request,
            });
        });
    }
    static bulkToggleActivation(request) {
        return __awaiter(this, void 0, void 0, function* () {
            return FetchService.postSingleResponse(BASE_URL + "/bulkToggleActivation", {
                request,
            });
        });
    }
    static bulkToggleSchedulerVisibility(request) {
        return __awaiter(this, void 0, void 0, function* () {
            return FetchService.postSingleResponse(BASE_URL + "/bulkToggleSchedulerVisibility", {
                request,
            });
        });
    }
}
